export const ClipIcon = ({ fill = '#808CB2' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M11.7734 14.3873L10.5587 15.602C9.71872 16.4426 8.57908 16.9149 7.39071 16.9149C6.20235 16.9149 5.06271 16.4426 4.22273 15.602V15.602C3.38232 14.7619 2.91016 13.6223 2.91016 12.434C2.91016 11.2457 3.38232 10.1061 4.22273 9.26603L5.44074 8.05469"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.41211 12.4154L12.5893 7.23828"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.22852 5.26656L9.44319 4.05189C10.283 3.21087 11.4227 2.73828 12.6112 2.73828C13.7997 2.73828 14.9394 3.21087 15.7792 4.05189V4.05189C16.6198 4.89187 17.0921 6.03152 17.0921 7.21988C17.0921 8.40824 16.6198 9.54788 15.7792 10.3879L14.5612 11.5992"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
